import styled from 'styled-components'

export const Container = styled.div``

type DatesProps = {
  alignItem?: boolean
}
export const Dates = styled.div<DatesProps>`
  align-items: ${({ alignItem }) => (alignItem ? 'flex-end' : 'center')};
  color: ${({ theme }) => theme.colors?.textColor};
  display: flex;
  font-family: 'Manrope', sans-serif;
  gap: 5px;
`

export const DatesCheck = styled.div`
  label {
    color: ${({ theme }) => theme.colors?.textColor};
    font-size: 10px;
    line-height: 13.66px;
  }

  p {
    color: ${({ theme }) => theme.colors?.textColor};
    font-size: 13px;
    font-weight: 500;
    line-height: 16.39px;
    margin: 0;
  }
`

export const Separator = styled.div`
  transform: rotate(270deg);
`
